module.exports = __webpack_public_path__ + "img/step4.d11de917.svg";